import { Button, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { useRouter } from "next/router";
import { useMobileNav } from "./layout/mobile-nav-context";
import { logger } from "utils/logger";

interface SidebarButtonProps {
  icon: ReactNode;
  href: string;
  label: string;
  active?: boolean;
  onClick?: Function;
}

export default function SidebarButton({ icon, href, label, active, onClick }: SidebarButtonProps) {
  const router = useRouter();
  const { closeMobileNav } = useMobileNav();

  const handleClick = async () => {
    if (onClick) {
      onClick();
    }
    // Close mobile nav if it's open
    if (closeMobileNav) {
      closeMobileNav();
    }

    try {
      await router.push(href);
    } catch (err: any) {
      logger.warn(`Router navigation aborted: ${err?.message}`);
    }
  };

  return (
    <Button
      leftIcon={icon as any}
      color={"special.desktopSidebarText"}
      backgroundColor={active ? "special.desktopSidebarTextHover" : undefined}
      _hover={{
        backgroundColor: "special.desktopSidebarTextHover",
      }}
      variant="ghost"
      size="sm"
      mb={"10px"}
      onClick={handleClick}
      data-tid={`sidebar-button-${href.replace(/\//g, "-")}`}
    >
      <Text w={"120px"} textAlign="left" style={{ textWrap: "balance" }}>
        {label}
      </Text>
    </Button>
  );
}
